// import { useToast } from 'primevue/usetoast';
import type { ToastMessageOptions } from 'primevue/toast';
import { createI18n } from 'vue-i18n';
import messages from '../i18n';
import app from '@/main';

const i18n = createI18n({
  locale: 'en',
  legacy: false,
  messages,
  globalInjection: true,
});
const { t } = i18n.global;

// export const toast = useToast();

// Default toast configuration
const defaultToastConfig: ToastMessageOptions = {
  life: 60000,
  styleClass: 'ml-5',
};

export const successToast = (config: ToastMessageOptions | string = {}) => {
  if (typeof config === 'string') {
    config = { detail: config };
  }

  app.config.globalProperties.$toast.add({
    severity: 'success',
    summary: t('common.success'),
    detail: t('common.operationSuccessful'),
    ...config,
    ...defaultToastConfig,
  });
};

export const errorToast = (config: ToastMessageOptions | string = {}) => {
  if (typeof config === 'string') {
    config = { detail: config };
  }

  app.config.globalProperties.$toast.add({
    severity: 'error',
    // summary: t('common.error'),
    detail: t('errors.unknownErrorMessage'),
    ...config,
    ...defaultToastConfig,
  });
};

export const infoToast = (config: ToastMessageOptions | string = {}) => {
  if (typeof config === 'string') {
    config = { detail: config };
  }

  app.config.globalProperties.$toast.add({
    severity: 'info',
    summary: t('common.info'),
    ...config,
    ...defaultToastConfig,
  });
};

export const warnToast = (config: ToastMessageOptions | string = {}) => {
  if (typeof config === 'string') {
    config = { detail: config };
  }

  app.config.globalProperties.$toast.add({
    severity: 'warn',
    summary: t('common.warning'),
    ...config,
    ...defaultToastConfig,
  });
};
